import React, { useEffect, useRef, useState } from 'react';
import Box from '../../../../../../../components/Layout/Components/Box/Box';
import Header from './Header/Header';
import ItemList from './ItemList/ItemList';
import Summary from './Summary/Summary';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToTransactionByBarcodeAction, getReceipt, resetState } from '../../actions';

import PaymentDialog from './Payment/PaymentDialog';
import { SUCCESS } from '../../../../../../../enums/states';
import { Prompt, useHistory } from 'react-router';
import useReduxReducer from '../../../../../../../hooks/useReduxReducer';
import receipt from '../../reducers';
import useBarcodeScanner from '../../../../../../../hooks/useBarcodeScanner';
import useKeyBoardListener from '../../../../../../../hooks/useKeyboardListener';
import { useIntl } from 'react-intl';

const Receipt = ({ transactionId }) => {
  const lines = useSelector((state) => state?.receipt?.lines);
  const header = useSelector((state) => state?.receipt?.header);
  const posting = useSelector((state) => state?.receipt?.header.metadata.posting);
  const cancelling = useSelector((state) => state?.receipt?.header?.metadata?.cancelling);
  const [openedDialog, setOpenedDialog] = useState(false);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isBlocking, setIsBlocking] = useState(false);
  const { formatMessage } = useIntl();

  useReduxReducer({ receipt });

  const { tray, clearTray } = useBarcodeScanner();
  const currentTray = useRef(tray);
  currentTray.current = tray;

  console.log(tray);

  const handleEnter = (key) => {
    const trayContent = currentTray.current;
    if (key.key === 'Enter') {
      if (trayContent) {
        dispatch(addItemToTransactionByBarcodeAction(transactionId, trayContent, 1));
        clearTray();
      }
    }
  };

  useEffect(() => {
    if (transactionId !== 'new') {
      setIsBlocking(true);
    } else {
      setIsBlocking(false);
    }
  }, [transactionId]);

  useKeyBoardListener(handleEnter);

  useEffect(() => {
    if (transactionId && transactionId !== 'new') {
      dispatch(getReceipt(transactionId));
    }
    return () => {
      dispatch(resetState());
    };
  }, [transactionId, dispatch]);

  useEffect(() => {
    setTotal(
      lines?.data?.reduce((accum, item) => {
        accum += parseFloat(item.data.amount);
        return accum;
      }, 0),
    );
  }, [lines?.data]);

  useEffect(() => {
    if (posting?.status === SUCCESS) {
      setIsBlocking(false);
      dispatch(resetState());
      history.push('/pos/sale');
    }
  }, [posting?.status, history, dispatch]);

  useEffect(() => {
    if (cancelling?.status === SUCCESS) {
      setIsBlocking(false);
      dispatch(resetState());
      history.push('/pos/sale');
    }
  }, [cancelling?.status, history, dispatch]);

  useEffect(() => {
    if (transactionId === 'new' && header?.data?.ID) {
      history.push('/pos/sale/' + header?.data?.ID);
    }
  }, [header?.data?.ID, history, transactionId]);

  return (
    <>
      <Prompt
        when={isBlocking && posting?.status !== SUCCESS && cancelling?.status !== SUCCESS}
        message={() =>
          formatMessage({ id: 'transaction.doYouWantToLeaveUnfinished' })
        }
      />

      <Box style={{ display: 'flex', flex: 1, flexDirection: 'column', margin: '0px 10px' }}>
        <PaymentDialog
          open={openedDialog}
          handleClose={() => {
            setOpenedDialog(false);
          }}
          total={total}
          transactionId={transactionId}
        />
        <Header transactionId={transactionId} />
        <ItemList transactionId={transactionId} />
        <Summary openDialog={() => setOpenedDialog(true)} />
      </Box>
    </>
  );
};

export default Receipt;
